import '../../assets/components/ContainmentBlock/containmentblock.css';const e = "_destyleList_rxiay_1", t = "_containmentHeader_rxiay_9", n = {
  destyleList: e,
  containmentHeader: t
};
export {
  t as containmentHeader,
  n as default,
  e as destyleList
};
